<div class="title">
  <h1>{{title}}</h1>

  <div class="buttonsContainer">

    <button mat-button (click)="refresh.emit()" *ngIf="showRefreshButton">
      <mat-icon>refresh</mat-icon>
      <span>{{'dashboard.common.header.refresh' | translate}}</span>
    </button>

    <button *ngIf="contentMenu.children.length > 0" mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">

      <div #contentMenu>
        <ng-content></ng-content>
      </div>

    </mat-menu>

  </div>

</div>
